import { render, staticRenderFns } from "./LargeNavbar.vue?vue&type=template&id=61c23f5d&scoped=true"
import script from "./LargeNavbar.vue?vue&type=script&lang=js"
export * from "./LargeNavbar.vue?vue&type=script&lang=js"
import style0 from "./LargeNavbar.vue?vue&type=style&index=0&id=61c23f5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c23f5d",
  null
  
)

export default component.exports